// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3pPKj","productName":"Table_productName__2FiIh"};